import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import { FiCheck, FiX } from 'react-icons/fi';
import '../styles/imageCropper.css';

export default function ImageCropper({ image, onCropComplete, onCancel }) {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    const onCropCompleteCallback = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const createCroppedImage = async () => {
        try {
            const croppedImage = await getCroppedImg(image, croppedAreaPixels);
            onCropComplete(croppedImage);
        } catch (e) {
            console.error('Error cropping image:', e);
            alert('Ошибка при обрезке изображения');
        }
    };

    return (
        <div className="imageCropperOverlay">
            <div className="imageCropperModal">
                <div className="imageCropperHeader">
                    <h3>Выберите область фото</h3>
                    <button className="closeButton" onClick={onCancel}>
                        <FiX />
                    </button>
                </div>
                
                <div className="cropperContainer">
                    <Cropper
                        image={image}
                        crop={crop}
                        zoom={zoom}
                        aspect={1}
                        onCropChange={setCrop}
                        onCropComplete={onCropCompleteCallback}
                        onZoomChange={setZoom}
                    />
                </div>

                <div className="cropperControls">
                    <div className="zoomControl">
                        <label>Масштаб</label>
                        <input
                            type="range"
                            value={zoom}
                            min={1}
                            max={3}
                            step={0.1}
                            onChange={(e) => setZoom(e.target.value)}
                        />
                    </div>
                    
                    <div className="cropperButtons">
                        <button className="cancelButton" onClick={onCancel}>
                            <FiX /> Отмена
                        </button>
                        <button className="confirmButton" onClick={createCroppedImage}>
                            <FiCheck /> Применить
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

// Функция для создания обрезанного изображения
const getCroppedImg = (imageSrc, pixelCrop) => {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.src = imageSrc;
        image.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            // Устанавливаем размер canvas равным обрезанной области
            canvas.width = pixelCrop.width;
            canvas.height = pixelCrop.height;

            ctx.drawImage(
                image,
                pixelCrop.x,
                pixelCrop.y,
                pixelCrop.width,
                pixelCrop.height,
                0,
                0,
                pixelCrop.width,
                pixelCrop.height
            );

            // Конвертируем canvas в base64
            canvas.toBlob((blob) => {
                if (!blob) {
                    reject(new Error('Canvas is empty'));
                    return;
                }
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = () => {
                    resolve(reader.result);
                };
            }, 'image/jpeg', 0.9);
        };
        image.onerror = reject;
    });
};
